import angular from 'angular';

import '../../services/datastorage';

//Redericts user to last visited department site.
angular.module('folkeuni').component('redirector', {
    bindings: {
        departmentUrl: '@',
        level: '<'
    },
    controller: function (DataStorage, $window) {
        var $ctrl = this;
        $ctrl.$onInit = function () {
            if ($ctrl.level > 1 && $ctrl.departmentUrl) {
                 DataStorage.set('lastVisitedDepartmentFrontpageUrl', $ctrl.departmentUrl);
            }
            else {
                 DataStorage.get("lastVisitedDepartmentFrontpageUrl").then(function (data) {
                     if (data != null && data.length > 0) {
                         if ($ctrl.level == 1) {
                             $window.location = data;
                         }
                     }
                 }, function (message) { });
            }
        }
    },
    template: ""
});